import React from 'react';

const OPTS = [
  { id: 'sparse',      label: 'Sparse',      hint: 'L0 only — executive scan' },
  { id: 'dense',       label: 'Dense',       hint: 'L0 + L1 (top drivers) — power-user default' },
  { id: 'comfortable', label: 'Comfortable', hint: 'L0 + L1 + L2 (full list) — fully expanded' },
];

export default function DensityChip({ value = 'dense', onChange }) {
  const btnBase = 'bg-transparent border-0 text-text-muted px-[9px] py-1 text-[0.72rem] font-[inherit] cursor-pointer border-r border-border last:border-r-0 hover:bg-surface-hover hover:text-text';
  return (
    <div className="inline-flex border border-border rounded-sm overflow-hidden bg-surface" role="group" aria-label="View density">
      {OPTS.map((o) => {
        const active = value === o.id;
        const state = active ? 'bg-surface-el text-accent-gold font-semibold' : '';
        return (
          <button
            key={o.id}
            type="button"
            className={`${btnBase} ${state}`}
            onClick={() => onChange(o.id)}
            title={o.hint}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
